/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The Footer component
 *
 * @author Thais Watanabe
 */
const Footer = (props) => {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 lg:max-w-7xl">
      <div className="border-t border-gray-200 py-8 text-sm text-gray-500 text-center sm:text-left">
        <span className="block sm:inline">&copy; {new Date().getFullYear()} 有限会社イー・ウィンド.</span>{" "}
        <span className="block sm:inline">All rights reserved.</span>
      </div>
    </div>
  );
};

export default Footer;
